import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DefaultVarianceRequest, VarianceRequest } from "./VarianceRequest";
import { ReduxUpdate } from "../../../../utils/ReduxUpdateCommands";
import { varianceApi } from "../../variance-api";
import { Individual } from "../individual/Individual";
import { IncidentTypeDetail } from "./IncidentTypeDetail";
import { VarianceDocument } from "./VarianceDocuments";
import { IncidentSubTypeDetail } from "./IncidentSubTypeDetail";

interface VarianceRequestState {
  varianceRequest: VarianceRequest;
}

const initialState: VarianceRequestState = {
  varianceRequest: DefaultVarianceRequest(),
};
export const VarianceRequestSlice = createSlice({
  name: "varianceRequest",
  initialState,
  reducers: {
    editVariance: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest[action.payload.name] = action.payload.value;
    },
    editVarianceIndividual: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.individual[action.payload.name] =
        action.payload.value;
    },
    setVarianceIndividual: (state, action: PayloadAction<Individual>) => {
      //@ts-ignore
      state.varianceRequest.individual = action.payload;
    },
    editVarianceLocation: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.location[action.payload.name] =
      action.payload.value;
    },
    editVarianceLocationDetails: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.locationDetails[action.payload.name] =
      action.payload.value;
    },
    editIncidentTypeDetails: (state, action: PayloadAction<IncidentTypeDetail>) => {
      //@ts-ignore
      state.varianceRequest.incidentTypeDetails.push(action.payload);
    },
    editMedicationEventMedDetails: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.medicationDetail[action.payload.name] =
      action.payload.value;
    },
    editDirectorResponseActions: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.directorResponseAction[action.payload.name] =
      action.payload.value;
    },
    editDirectorResponseFallActions: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.directorResponseAction.fallAction[action.payload.name] =
      action.payload.value;
    },
    editFollowUp: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.followUp[action.payload.name] = 
      action.payload.value;
    },
    addVarianceDocument: (state, action: PayloadAction<VarianceDocument>) => {
      state.varianceRequest.documents.push(action.payload);
    },
    addAssignedUser: (state, action: PayloadAction<ReduxUpdate>) => {
      //@ts-ignore
      state.varianceRequest.assignedUsers.push(action.payload.value);
    },
    removeAssignedUser: (state, action: PayloadAction<string>) => {
      //@ts-ignore
      state.varianceRequest.assignedUsers = state.varianceRequest.assignedUsers.filter(user => user.upn !== action.payload.value);
    },
    editSubTypeDetail: (state, action: PayloadAction<IncidentSubTypeDetail>) => {
      //@ts-ignore
      state.varianceRequest.incidentSubTypeDetails.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        varianceApi.endpoints.findVarianceRequest.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest = payload;
        }
      ).addMatcher(
        varianceApi.endpoints.incidentCommentAdd.matchFulfilled,
        (state,{payload}) => {state.varianceRequest.comments.push(payload)}
      ).addMatcher(
        varianceApi.endpoints.incidentCommentEdit.matchFulfilled,
        (state, { payload }) => {
          const commentIndex = state.varianceRequest.comments.findIndex(
            comment => comment.commentId === payload.commentId
          );
          if (commentIndex !== -1) {
            state.varianceRequest.comments[commentIndex] = payload;
          }
        }
      ).addMatcher(
        varianceApi.endpoints.incidentCommentDelete.matchFulfilled,
        (state, { meta }) => {
          const commentId = meta.arg.originalArgs.CommentId;
          state.varianceRequest.comments = state.varianceRequest.comments.filter(
            comment => comment.commentId !== commentId
          );
        }
      ).addMatcher(
        varianceApi.endpoints.varianceStatusUpdate.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest = payload;
        }
      ).addMatcher(
        varianceApi.endpoints.variancePending.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.varianceApprove.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.variancePendingApprove.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.varianceReject.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.varianceComplete.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.incidentWitnessAdd.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.witnesses?.push(payload);
          }
      ).addMatcher(varianceApi.endpoints.documentRemove.matchFulfilled,
        (state,{payload})=>{state.varianceRequest.documents = state.varianceRequest.documents.filter(x=>x.id !== payload.id)})
      .addMatcher(
        varianceApi.endpoints.varianceReopen.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.status = payload.currentStatus;
        }
      ).addMatcher(
        varianceApi.endpoints.directorResponseAdd.matchFulfilled,
        (state, { payload }) => {
          state.varianceRequest.directorResponses.push(payload);
        }
      ).addMatcher(
        varianceApi.endpoints.directorResponseEdit.matchFulfilled,
        (state, { payload }) => {
          const index = state.varianceRequest.directorResponses.findIndex(
            r => r.directorResponseId === payload.directorResponseId
          );
          if (index !== -1) {
            state.varianceRequest.directorResponses[index] = payload;
          }
        }
      ).addMatcher(
        varianceApi.endpoints.directorResponseDelete.matchFulfilled,
        (state, { meta }) => {
          const responseId = meta.arg.originalArgs.DirectorResponseId;
          state.varianceRequest.directorResponses = state.varianceRequest.directorResponses.filter(
            r => r.directorResponseId !== responseId
          );
        }
      );
  },
});

export const {
  editVariance,
  editVarianceIndividual,
  setVarianceIndividual,
  editVarianceLocation,
  editVarianceLocationDetails,
  editIncidentTypeDetails,
  editMedicationEventMedDetails,
  editDirectorResponseActions,
  editDirectorResponseFallActions,
  editFollowUp,
  addVarianceDocument,
  editSubTypeDetail,
  addAssignedUser,
  removeAssignedUser,
} = VarianceRequestSlice.actions;
export default VarianceRequestSlice.reducer;
